import React from 'react';
import { DeviceInfo } from '../../types';
import { SimpleGrid, Skeleton } from '@chakra-ui/react';
import { useIntl } from 'react-intl';
import { TextValueField } from '../common/TextValueField';
import { MdDevices, MdPhoneAndroid, MdLaptop, MdMemory, MdWifi } from 'react-icons/md';

type DeviceInfoTableProps = {
    deviceInfo?: Partial<DeviceInfo> | null;
    isLoading?: boolean;
};

export const DeviceInfoTable: React.FC<DeviceInfoTableProps> = ({ deviceInfo, isLoading }) => {
    const intl = useIntl();

    if (isLoading) {
        return <Skeleton height={150} />;
    }

    if (!deviceInfo) {
        return null;
    }

    return (
        <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={4}>
            <TextValueField
                smallVariant
                canCopy
                label={intl.formatMessage({ id: 'device.platform' })}
                value={deviceInfo?.platform ?? '-'}
                icon={<MdDevices />}
            />
            <TextValueField
                smallVariant
                canCopy
                label={intl.formatMessage({ id: 'device.name' })}
                value={deviceInfo?.deviceName ?? '-'}
                icon={<MdPhoneAndroid />}
            />
            <TextValueField
                smallVariant
                canCopy
                label={intl.formatMessage({ id: 'device.model' })}
                value={deviceInfo?.deviceId ?? '-'}
                icon={<MdLaptop />}
            />
            <TextValueField
                smallVariant
                canCopy
                label={intl.formatMessage({ id: 'device.brand' })}
                value={deviceInfo?.brand ?? '-'}
                icon={<MdMemory />}
            />
            {deviceInfo?.operatingSystem && (
                <TextValueField
                    smallVariant
                    canCopy
                    label={intl.formatMessage({ id: 'device.operatingSystem' })}
                    value={deviceInfo.operatingSystem}
                    icon={<MdDevices />}
                />
            )}
            {deviceInfo?.ipAddress && (
                <TextValueField
                    smallVariant
                    canCopy
                    label={intl.formatMessage({ id: 'device.ipAddress' })}
                    value={deviceInfo.ipAddress}
                    icon={<MdWifi />}
                />
            )}
        </SimpleGrid>
    );
};
